// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React, { useState } from 'react';
import { assign as _assign } from 'lodash';

import { useUpdatePipelineIntegration } from '@ion/api';
import { MrErrorModal } from '@ion/components';

import PipelineIntegrationForm from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/pipeline-integration-form/PipelineIntegrationForm';
import { CONSENT_FORM_TYPES } from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/pipeline-integration-form/CONSENT_FORM_TYPES';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';
import { usePipelineIntegrationModalContext } from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/context/pipeline-integration-modal-context';

export const EditIntegration = () => {
  const [errorMsg, setErrorMsg] = useState(null);
  const { pipeline } = usePipelinePageContext();
  const { onCloseModal, selectedIntegration } = usePipelineIntegrationModalContext();
  const [updatePipelineIntegration] = useUpdatePipelineIntegration({
    onCompleted: () => {
      onCloseModal();
    },
    onError: err => {
      setErrorMsg(err.errorMsg);
    },
  });

  const onSubmit = data => {
    updatePipelineIntegration({
      pipelineIntegration: selectedIntegration.pipelineIntegration,
      playbookId: data.revision,
      consentCategoryId: data.consentCategory,
      consentMode: data.consentMode,
      pipelineVars: _assign({}, selectedIntegration.mergedPipelineVars, data.pipelineVars),
      readyForDeploy: true,
      disabled: selectedIntegration.pipelineIntegration.disabled,
    });
  };
  return (
    <>
      <PipelineIntegrationForm
        pipeline={pipeline}
        onSubmit={onSubmit}
        type={CONSENT_FORM_TYPES.update}
        onCancel={onCloseModal}
        selectedIntegration={selectedIntegration}
      />

      {errorMsg && (
        <MrErrorModal
          header="Error Editing Staged Revision"
          errorMessage={errorMsg}
          closeModal={() => setErrorMsg(false)}
        />
      )}
    </>
  );
};
